import { Component, OnInit, Input } from '@angular/core';
import { PCCService } from 'src/app/services/pcc.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-patient-nutrition-orders',
  templateUrl: './patient-nutrition-orders.component.html',
  styleUrls: ['./patient-nutrition-orders.component.css']
})
export class PatientNutritionOrdersComponent implements OnInit {

  @Input('patient') patient;
  // @Input('pccOrgUuid') pccOrgUuid;
  constructor(private _pccService: PCCService,
    private toastr:ToastrService,
    private loader: NgxUiLoaderService) { }
  pccOrgUuid:string;
  apiData;
  dataSource;
  displayedColumns = [
    "nutritionOrderId",
    "status",
    "oralDiet", // object
    "orderedBy",
    "orderedById",
    "orderDateTime",
    "patientId",
  ];

  loaderId ='patient-nutrition-orders-loader';
  inprogress = false;

  
  view:''|'oralDiet' = '';
  viewData;

  ngOnInit(): void {
    this.pccOrgUuid = this.patient.facility_id_ref.pcc_orgUuid;
    this.loadData();
  }

  loadData() {
    this.loader.startLoader(this.loaderId);
    let authMode;
    if(!this.patient.facility_id_ref.pcc_2_legged_authentication) {
      authMode = 'APP'
    }
    this._pccService.getPatientNutritionOrders({
      pccOrgUuid:this.pccOrgUuid,
      pccPatientId:this.patient.pcc_patientId,
      authMode
    }).subscribe((response: any) => {

      if (response.status === 200) {
        this.apiData = response.data;
        this.dataSource = new MatTableDataSource(this.apiData.data);
      } else {
        this.toastr.error('Something went wrong while fetching Patient Nutrition Orders data');
      }
    }, (error) => {
      this.toastr.error('Something went wrong while fetching Patient Nutrition Orders data');
    }, () => {
      this.loader.stopLoader(this.loaderId);
    })
  }
}
